import { render, staticRenderFns } from "./ApprovedBOM.vue?vue&type=template&id=31bbee88&"
import script from "./ApprovedBOM.vue?vue&type=script&lang=js&"
export * from "./ApprovedBOM.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedBOM.vue?vue&type=style&index=0&id=31bbee88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports